// extracted by mini-css-extract-plugin
export default {"container":"youtube-video_container__vUEI2","iframe":"youtube-video_iframe__MYG-C","overlay":"youtube-video_overlay__2MEla"};